import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import ReactDOM from "react-dom/client"
import { ChakraColorProvider } from "../src/components/UI/provider"
import { routeTree } from "./routeTree.gen"
import "vanilla-cookieconsent/dist/cookieconsent.css"
import { StrictMode } from "react"
import { OpenAPI } from "./client"
import { Toaster } from "./components/UI/toaster"
import { CookieConsentProvider } from "./components/UI/cookieconsent-config"
import { SettingsProvider } from "./components/UI/settings-context"
import { AuthProvider } from "./components/UI/auth-provider"
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT

OpenAPI.BASE = import.meta.env.VITE_API_URL
OpenAPI.TOKEN = async () => {
  return localStorage.getItem("access_token") || ""
}

const queryClient = new QueryClient()

const router = createRouter({ routeTree })
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <CookieConsentProvider />
    {ENVIRONMENT == "local" ? (
      <StrictMode>
        <ChakraColorProvider>
          <AuthProvider>
            <QueryClientProvider client={queryClient}>
              <SettingsProvider>
                <RouterProvider router={router} />
                <Toaster />
              </SettingsProvider>
            </QueryClientProvider>
          </AuthProvider>
        </ChakraColorProvider>
      </StrictMode>
    ) : (
      <ChakraColorProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <SettingsProvider>
              <RouterProvider router={router} />
              <Toaster />
            </SettingsProvider>
          </QueryClientProvider>
        </AuthProvider>
      </ChakraColorProvider>
    )}
  </>
)
